import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { invitationGet } from "../../store/API/invitationsAPI";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";
import SliderInv from "../SliderInv/SliderInv";

const Invitations = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const lastSegment = pathname.split("/").filter(Boolean).pop();
  const selectedLanguages = useSelector(selectedLanguage);

  useEffect(() => {
    if (lastSegment) {
      dispatch(invitationGet(lastSegment));
    }
  }, [lastSegment, dispatch]);

  return (
    <section className="website-templates">
      <div className="website-templates__container container">
        <h3>{translations[selectedLanguages]?.templatesMain?.invitations}</h3>
        <SliderInv />
      </div>
      <Outlet />
    </section>
  );
};

export default Invitations;
